/* tslint:disable */
/* eslint-disable */
/**
 * leverup Service Application
 * Documentation for your application APIs v1.0
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  TradingVolumeResponse,
  TradingVolumeSummaryResponse,
} from '../models/index';

export interface GetTotalTradingVolumesRequest {
    chains?: Array<GetTotalTradingVolumesChainsEnum>;
}

export interface GetTotalTradingVolumesByDateRequest {
    startTime: string;
    endTime: string;
    chains?: Array<GetTotalTradingVolumesByDateChainsEnum>;
}

export interface GetUsersTradingVolumesRequest {
    startTime: string;
    endTime: string;
    chains?: Array<GetUsersTradingVolumesChainsEnum>;
}

/**
 * 
 */
export class TradingVolumeControllerApi extends runtime.BaseAPI {

    /**
     */
    async getTotalTradingVolumesRaw(requestParameters: GetTotalTradingVolumesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TradingVolumeSummaryResponse>> {
        const queryParameters: any = {};

        if (requestParameters['chains'] != null) {
            queryParameters['chains'] = requestParameters['chains'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/v1/trading-volumes/sum-all`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async getTotalTradingVolumes(requestParameters: GetTotalTradingVolumesRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TradingVolumeSummaryResponse> {
        const response = await this.getTotalTradingVolumesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getTotalTradingVolumesByDateRaw(requestParameters: GetTotalTradingVolumesByDateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TradingVolumeSummaryResponse>> {
        if (requestParameters['startTime'] == null) {
            throw new runtime.RequiredError(
                'startTime',
                'Required parameter "startTime" was null or undefined when calling getTotalTradingVolumesByDate().'
            );
        }

        if (requestParameters['endTime'] == null) {
            throw new runtime.RequiredError(
                'endTime',
                'Required parameter "endTime" was null or undefined when calling getTotalTradingVolumesByDate().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['chains'] != null) {
            queryParameters['chains'] = requestParameters['chains'];
        }

        if (requestParameters['startTime'] != null) {
            queryParameters['startTime'] = requestParameters['startTime'];
        }

        if (requestParameters['endTime'] != null) {
            queryParameters['endTime'] = requestParameters['endTime'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/v1/trading-volumes/sum-by-date`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async getTotalTradingVolumesByDate(requestParameters: GetTotalTradingVolumesByDateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TradingVolumeSummaryResponse> {
        const response = await this.getTotalTradingVolumesByDateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getUsersTradingVolumesRaw(requestParameters: GetUsersTradingVolumesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<TradingVolumeResponse>>> {
        if (requestParameters['startTime'] == null) {
            throw new runtime.RequiredError(
                'startTime',
                'Required parameter "startTime" was null or undefined when calling getUsersTradingVolumes().'
            );
        }

        if (requestParameters['endTime'] == null) {
            throw new runtime.RequiredError(
                'endTime',
                'Required parameter "endTime" was null or undefined when calling getUsersTradingVolumes().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['chains'] != null) {
            queryParameters['chains'] = requestParameters['chains'];
        }

        if (requestParameters['startTime'] != null) {
            queryParameters['startTime'] = requestParameters['startTime'];
        }

        if (requestParameters['endTime'] != null) {
            queryParameters['endTime'] = requestParameters['endTime'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/v1/trading-volumes/users`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async getUsersTradingVolumes(requestParameters: GetUsersTradingVolumesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<TradingVolumeResponse>> {
        const response = await this.getUsersTradingVolumesRaw(requestParameters, initOverrides);
        return await response.value();
    }

}

/**
  * @export
  * @enum {string}
  */
export enum GetTotalTradingVolumesChainsEnum {
    Monad = 'MONAD'
}
/**
  * @export
  * @enum {string}
  */
export enum GetTotalTradingVolumesByDateChainsEnum {
    Monad = 'MONAD'
}
/**
  * @export
  * @enum {string}
  */
export enum GetUsersTradingVolumesChainsEnum {
    Monad = 'MONAD'
}
